/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queues_Empty_HintInputs */

const en_queues_empty_hint = /** @type {(inputs: Queues_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New work will show up here as soon as it reaches you.`)
};

/**
* | output |
* | --- |
* | "New work will show up here as soon as it reaches you." |
*
* @param {Queues_Empty_HintInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queues_empty_hint = /** @type {((inputs?: Queues_Empty_HintInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queues_Empty_HintInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queues_empty_hint(inputs)
});